import { ColorIcon, colors, GOI_PLATFORM_URL, VStack } from "goi_common";
import { useRouter } from "next/router";
import React, { useMemo, useEffect } from "react";

import {
  Box,
  useDisclosure,
  Text,
  Button,
  IconButton,
  Modal,
  ModalContent,
  ModalOverlay,
  VStack as ChakraVStack,
} from "@chakra-ui/react";

import { Header } from "./Header";
import Menu from "./Menu";
import TossHeader from "./TossHeader";
import { tossLocalStorage } from "@/utils/storage";
import BeforeHeader from "./BeforeHeader";
import { useCustomVariation } from "@/hooks/useCustomVariation";
// import * as ChannelService from "@channel.io/channel-web-sdk-loader";
// import { useOverlay } from "@toss/use-overlay";

// ChannelService.loadScript();

interface LayoutProps {
  children: React.ReactNode;
  showConditional?: boolean;
}

export default function Layout({ children, showConditional }: LayoutProps) {
  const router = useRouter();
  // const overlay = useOverlay();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isRevisitModalOpen,
    onOpen: onRevisitModalOpen,
    onClose: onRevisitModalClose,
  } = useDisclosure();

  const isRouteIncludeToss = router.route.includes("toss");

  const variation = useCustomVariation(143);
  const isVariationA = variation === "A";

  useEffect(() => {
    if (
      router.route.includes("toss") ||
      router.route.includes("registration")
    ) {
      return;
    }

    const visitCountStr = tossLocalStorage.get("goi-visit-count");
    let visitCount = 1;
    if (visitCountStr === null) {
      tossLocalStorage.set("goi-visit-count", "1");
    } else {
      visitCount = parseInt(visitCountStr, 10) + 1;
      tossLocalStorage.set("goi-visit-count", visitCount.toString());
    }
    if (visitCount === 2 || (visitCount > 2 && visitCount < 5)) {
      setTimeout(() => {
        onRevisitModalOpen();
      }, 10000);
    }
    // visitCount가 5 이상이면 모달을 노출하지 않음
  }, [onRevisitModalOpen]);

  // useEffect(() => {
  //   if (router.route.includes("/verification")) {
  //     return;
  //   }

  //   ChannelService.boot({
  //     pluginKey: process.env.NEXT_PUBLIC_CHANNELTALK_PLUGIN_KEY as string,
  //   });

  //   ChannelService.onShowMessenger(() => {
  //     overlay.open(({ isOpen, close: onClose }) => {
  //       return (
  //         <Modal
  //           isOpen={isOpen}
  //           onClose={() => {
  //             onClose();
  //           }}
  //           closeOnOverlayClick={false}
  //           scrollBehavior="inside"
  //           isCentered={true}
  //           autoFocus={false}
  //           closeOnEsc={false}
  //           returnFocusOnClose={false}
  //         >
  //           <ModalOverlay width="100%" height="100%" />
  //         </Modal>
  //       );
  //     });
  //   });
  //   ChannelService.onHideMessenger(() => {
  //     overlay.close();
  //   });
  //   return () => {
  //     ChannelService.shutdown();
  //   };
  // }, []);

  const isHeaderHidden = useMemo(() => {
    if (showConditional) {
      return false;
    }

    return (
      router.route === "/login" ||
      router.route.includes("contract-check/") ||
      router.route.includes("contract-confirm") ||
      router.route === "/register-pay-method" ||
      router.route === "/register-pay-method/failure" ||
      router.route.includes("/event") ||
      router.route.includes("closed") ||
      router.route === "/content/feeds/sangjo" ||
      router.route === "/content/feeds/ceo-youtube" ||
      router.route.includes("review/") ||
      router.route.includes("content/feeds/tip") ||
      router.route === "/content/feeds/youtube/luckyquiz" ||
      router.route === "/call-lead" ||
      router.route.includes("content") ||
      isRouteIncludeToss
    );
  }, [router, showConditional]);

  return (
    <>
      {!isHeaderHidden &&
        (isVariationA ? (
          <Header onOpen={onOpen} />
        ) : (
          <BeforeHeader onOpen={onOpen} />
        ))}

      {isRouteIncludeToss &&
        !router.route.includes("registration/toss-payment") && (
          <TossHeader onOpen={onOpen} />
        )}

      <VStack>
        {children}

        {/* <FixedCTA /> */}
      </VStack>

      <Menu isOpen={isOpen} onClose={onClose} />
      <RevisitModal isOpen={isRevisitModalOpen} onClose={onRevisitModalClose} />
    </>
  );
}

function RevisitModal({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  const router = useRouter();

  const handleConsultClick = () => {
    router.push("/call-lead");
    onClose();
  };

  const handleMoreInfoClick = () => {
    router.push("/");
    onClose();
  };

  const isPrimePaymentSuccess = tossLocalStorage.get("primePaymentSuccess");

  const isRouteIncludeContract = router.route.includes("/contract");

  const isDiffContent = isPrimePaymentSuccess || isRouteIncludeContract;

  const isHiddenRoute =
    router.route.includes("registration/verification") ||
    router.route.includes("registration/address") ||
    router.route.includes("registration/email") ||
    router.route.includes("registration/confirmation-");

  if (isHiddenRoute) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      motionPreset="slideInBottom"
    >
      <ModalOverlay />
      <ModalContent
        mx="16px"
        borderRadius="16px"
        p={0}
        overflow="hidden"
        w="calc(100% - 32px)"
        maxW="360px"
      >
        <IconButton
          aria-label="닫기"
          icon={<ColorIcon name="icon-x-mono" size={20} color={colors.black} />}
          size="sm"
          variant="ghost"
          position="absolute"
          top="16px"
          right="16px"
          onClick={onClose}
          zIndex={1}
        />
        <Box p="48px 24px 32px">
          {isDiffContent ? (
            <>
              {" "}
              <Text
                fontSize="22px"
                fontWeight="bold"
                lineHeight="30px"
                color="gray.800"
                whiteSpace="pre-wrap"
              >
                장례 준비, 막막하신가요?
              </Text>
              <Text
                mt="24px"
                fontSize="16px"
                lineHeight="26px"
                color="gray.800"
                whiteSpace="pre-wrap"
              >
                장례 준비, 어디서부터 해야될지 고민되시죠? <br />
                <br />
                장례식장, 장지 등 고객님의 상황을 고려해 <br />
                <Text as="span" color={colors.orange650} fontWeight="bold">
                  맞춤형 장례 준비
                </Text>
                를 도와드릴게요.
              </Text>
            </>
          ) : (
            <>
              <Text
                fontSize="22px"
                fontWeight="bold"
                lineHeight="30px"
                color="gray.800"
                whiteSpace="pre-wrap"
              >
                가입이 고민되시나요?
                <br />
                지금 바로 전문가와 상담받아보세요.
              </Text>
              <Text
                mt="24px"
                fontSize="16px"
                lineHeight="26px"
                color="gray.800"
                whiteSpace="pre-wrap"
              >
                상품 구조, 비용 때문에 가입이 고민되신다면,{"\n"}
                <Text as="span" color={colors.orange650} fontWeight="bold">
                  전문가에게 상담
                </Text>
                {" 받아보시는 건 어떠세요?"}
              </Text>
              <Text
                mt="16px"
                fontSize="16px"
                lineHeight="26px"
                color="gray.800"
                whiteSpace="pre-wrap"
              >
                고객님의 상황에 맞춰 친절하게 설명해드리겠습니다.
              </Text>
            </>
          )}
        </Box>

        <ChakraVStack spacing="8px" align="stretch" p="0 24px 24px">
          {isDiffContent ? (
            <>
              <Button
                w="100%"
                h="56px"
                bg={colors.orange650}
                color="white"
                _hover={{ bg: colors.orange700 }}
                onClick={() => {
                  router.push(GOI_PLATFORM_URL + "/match/request/");
                }}
                fontSize="16px"
                fontWeight="bold"
                borderRadius="8px"
              >
                장례 준비 도움받기
              </Button>
            </>
          ) : (
            <>
              <Button
                w="100%"
                h="56px"
                bg={colors.orange650}
                color="white"
                _hover={{ bg: colors.orange700 }}
                onClick={handleConsultClick}
                fontSize="16px"
                fontWeight="bold"
                borderRadius="8px"
              >
                전문가와 상담받기
              </Button>
              <Button
                w="100%"
                h="56px"
                bg={colors.gray800}
                color="white"
                _hover={{ bg: colors.gray900 }}
                onClick={handleMoreInfoClick}
                fontSize="16px"
                fontWeight="bold"
                borderRadius="8px"
              >
                100원 상조 더 알아보기
              </Button>
            </>
          )}
        </ChakraVStack>
      </ModalContent>
    </Modal>
  );
}

// function FixedCTA() {
//   const [isFixedCTA, setIsFixedCTA] = useState(false);
//   const isInitialized = useRef(false);
//   const hasLeftHome = useRef(false);

//   const router = useRouter();

//   useEffect(() => {
//     if (isInitialized.current) return;

//     const isHomePage = router.pathname === "/";
//     const isCalculatorPage = router.pathname.includes("/calculator/");

//     if (isHomePage || isCalculatorPage) {
//       setIsFixedCTA(false);
//     } else {
//       setIsFixedCTA(true);
//     }
//     isInitialized.current = true;
//   }, []);

//   useEffect(() => {
//     if (hasLeftHome.current) return;

//     const isHomePage = router.pathname === "/" || router.pathname.includes("/calculator/");

//     if (!isHomePage) {
//       setIsFixedCTA(true);
//       hasLeftHome.current = true;
//     }
//   }, [router.pathname]);

//   const texts = [
//     "숨겨진 약관 있을까?",
//     "해지 100% 환급?",
//     "월 100원 진짜 가능?",
//     "가입 후 회사 망하면?",
//     "장례시 추가금 지불?",
//   ];
//   const [currentIdx, setCurrentIdx] = useState(0);
//   const [isFading, setIsFading] = useState(false);
//   const timeoutRef = useRef<NodeJS.Timeout | null>(null);
//   const fadeDuration = 400;
//   const showDuration = 2000;

//   useEffect(() => {
//     timeoutRef.current = setTimeout(() => {
//       setIsFading(true);
//       setTimeout(() => {
//         setIsFading(false);
//         setCurrentIdx((prev) => (prev + 1) % texts.length);
//       }, fadeDuration);
//     }, showDuration);
//     return () => {
//       if (timeoutRef.current) clearTimeout(timeoutRef.current);
//     };
//   }, [currentIdx]);

//   if (!isFixedCTA) {
//     return (
//       <Box
//         position="fixed"
//         bottom="150px"
//         right="16px"
//         bg="white"
//         boxShadow="0px 0px 16px rgba(0, 0, 0, 0.15)"
//         borderRadius="50%"
//         zIndex={2000}
//         height="40px"
//         width="40px"
//         overflow="hidden"
//         display="flex"
//         alignItems="center"
//         justifyContent="center"
//         fontSize="14px"
//         fontWeight="bold"
//         color="white"
//         lineHeight="16px"
//         whiteSpace="nowrap"
//         textAlign="center"
//         cursor="pointer"
//         backgroundColor={colors.orange650}
//         onClick={() => {
//           setIsFixedCTA(true);
//         }}
//       >
//         <ColorIcon name="icon-call-mono" size={14} color={colors.white} />
//       </Box>
//     );
//   }

//   return (
//     <Box
//       position="fixed"
//       bottom="150px"
//       right="16px"
//       bg="white"
//       boxShadow="0px 0px 16px rgba(0, 0, 0, 0.15)"
//       borderRadius="16px"
//       p="34px 0px 20px 0px"
//       zIndex={2000}
//       width="160px"
//       minW="160px"
//       maxW="160px"
//       overflow="hidden"
//     >
//       <IconButton
//         aria-label="닫기"
//         icon={<ColorIcon name="icon-x-mono" size={14} color={colors.gray500} />}
//         size="sm"
//         variant="ghost"
//         position="absolute"
//         top="6px"
//         right="6px"
//         onClick={() => {
//           setIsFixedCTA(false);
//         }}
//       />
//       <Box
//         height="24px"
//         overflow="hidden"
//         display="flex"
//         alignItems="center"
//         justifyContent="center"
//         mb="4px"
//         position="relative"
//         width="100%"
//       >
//         <Box display="flex" alignItems="center" justifyContent="center" width="100%">
//           <Text
//             fontWeight="bold"
//             fontSize="16px"
//             textAlign="center"
//             lineHeight="18px"
//             whiteSpace="nowrap"
//             flexShrink={0}
//             style={{
//               transition: `opacity ${fadeDuration}ms ease-in-out`,
//               opacity: isFading ? 0 : 1,
//             }}
//           >
//             {texts[currentIdx]}
//           </Text>
//         </Box>
//       </Box>
//       <Text fontSize="14px" color="gray.600" mb="16px" textAlign="center" lineHeight="16px">
//         걱정되신다면
//       </Text>
//       <Box padding="0px 12px">
//         <Button
//           width="100%"
//           backgroundColor={colors.orange650}
//           color={colors.white}
//           fontWeight="bold"
//           fontSize="16px"
//           borderRadius="8px"
//           onClick={() => {
//             setIsFixedCTA(false);
//             router.push("/call-lead");
//           }}
//         >
//           상담으로 알아보기
//         </Button>
//       </Box>
//     </Box>
//   );
// }
